// 表单验证器
export default {
  methods: {
    validate (key = 'formValue') {
      return this.$validator.validateAll().then(result => {
        if (result) {
          return Promise.resolve(this[key])
        } else {
          let message = this.errors.items
            ? this.errors.items[0].msg
            : '验证出现异常！'
          this.$message.error(message)
          return Promise.reject(message)
        }
      })
    }
  }
}
